import { store } from '@/store'
import { NavigationGuardNext, Route } from 'vue-router'
import { getDeepLinkParams } from './router-helpers'

/**
 * SigninGuard
 * 
 * Checks for a 'signin' token set as a route query parameter.  If a token
 * is found, attempts to login an authenticated user
 */
export default async (to: Route, from, next: NavigationGuardNext) => {
    //  Create a 'pass' function
    const pass = (why: string, route: string = null): void => {
        store.getters.appDebug && console.log(`GUARD: invitation-guard pass. (${why})`)

        //  If we have a route, go there
        if (route) return next(route)

        //  Else, just go to the default
        return next()
    }

    //  Create a 'fail' function
    const fail = (why: string, route: string = null): void => {
        store.getters.appDebug && console.error(`GUARD: invitation-guard stop. (${why})`)

        //  Get deep link params (if valid) for redirecting after signin
        const params = getDeepLinkParams(to)

        //  Our path is either the route or signin
        const path = route ? `${route}${params}` : `/signin${params}`
        console.log('path', path)

        //  Redirect to our path
        return next(path)
    }

    //  Check for the auto 'signin' token
    const token = to.query.signin || null

    //  If the token does NOT exist, we pass the guard
    if (!token) return pass('token not in query')

    //  Else, fetch the authenticated user with the token
    const auth = await store.dispatch('authUserGet', {'userToken': token})

    //  If the user does NOT exist, guard fails
    if (!auth.user) return fail('no user')

    //  Check if our user has password set
    const passwordSet = auth.user.password_set

    //  If it isn't set, just pass
    if (!passwordSet) return pass('password not set')

    //  Check if our user has a mobilephone
    const mobilephone = auth.user.mobilephone

    //  If they don't, just pass
    if (!mobilephone) return pass('mobilephone not set')

    //  Check if our user has mobilephone verified
    const verified = auth.user.mobilephone_verified

    //  If not, then route to verify
    if (!verified) return fail('mobilephone not verified', '/register/verifysms')

    //  Else, check for a tenant attached to the url
    const tenantId = to.query.tenant || null

    //  If a tenant id exists, load the tenant
    if (tenantId) await store.dispatch('tenantGet', tenantId)

    //  Guard passes!
    return pass('successful signin', '/inbox')
}
